module.exports = __webpack_public_path__ + "static/wand_of_orcus-a6c6daebaf5b7b3815d9fbef7c5214b9.jpeg";